"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeHxLocationEntityDataResults = void 0;
var HxTimeSlotAvailabilityDataResults_1 = require("./HxTimeSlotAvailabilityDataResults");
function deserializeHxLocationEntityDataResults(values) {
    var i = 0;
    var displayName = values[i++];
    var streetAddress = values[i++];
    var city = values[i++];
    var state = values[i++];
    var country = values[i++];
    var postalCode = values[i++];
    var latitude = values[i++];
    var longitude = values[i++];
    var accuracy = values[i++];
    var locationUri = values[i++];
    var locationSource = values[i++];
    var locationId = values[i++];
    var locationIdType = values[i++];
    var timeSlotAvailabilitiesValues = values[i++];
    var timeSlotAvailabilities = new Array(timeSlotAvailabilitiesValues.length);
    for (var index = 0; index < timeSlotAvailabilitiesValues.length; index++) {
        timeSlotAvailabilities[index] = HxTimeSlotAvailabilityDataResults_1.deserializeHxTimeSlotAvailabilityDataResults(timeSlotAvailabilitiesValues[index]);
    }
    if (i != values.length) {
        throw "Result values not parsed completely";
    }
    return { displayName: displayName, streetAddress: streetAddress, city: city, state: state, country: country, postalCode: postalCode, latitude: latitude, longitude: longitude, accuracy: accuracy, locationUri: locationUri, locationSource: locationSource, locationId: locationId, locationIdType: locationIdType, timeSlotAvailabilities: timeSlotAvailabilities };
}
exports.deserializeHxLocationEntityDataResults = deserializeHxLocationEntityDataResults;
